export default {
  all: "Todos",
  money: "Dinheiro",
  debit_card: "Débito",
  credit_card: "Crédito (À vista)",
  installments: "Crédito (Parcelado)",
  mp_qr_code: "QR Code (Mercado Pago)",
  credit_coupon: "Cupom de Troca",
  voucher: "Voucher",
  others: "Outros",
  bank_slip: "Boleto Bancario",
  devolution: "Devolução"
  // cheque: "Cheque",
  // store_credit: "Crédito Loja",
  // alimentation_ticket: "Vale Alimentação",
  // meal_ticket: "Vale Refeição",
  // gift_ticket: "Vale Presente",
  // fuel_ticket: "Vale Combustível",
  // bank_slip: "Boleto Bancário",
  // no_payment: "Sem Pagamento",
};



// WEBPACK FOOTER //
// ./src/core/enum/payment-types.enum.js